import { useT } from '../../../../i18n';
import { soVN } from '../../../../lib/dinh-dang';
import type { AskDisplay } from '../../types';
import { KhoiSoLieu } from './KhoiSoLieu';

/**
 * Đọc `payload` của một tin nhắn đã lưu rồi vẽ lại biểu đồ và bảng của lượt ấy. Dùng ở Hỏi đáp AI, chat với bot và
 * lịch sử trò chuyện của màn Nhật ký.
 *
 * `payload` là khối JSON tự do — nền tảng cố ý không diễn giải — nên mọi trường đều CÓ THỂ VẮNG hoặc sai kiểu: tin nhắn
 * lưu trước bản này không có `rows`, và vẫn phải mở lại được.
 */
export function KhoiSoLieuDaLuu({ payload }: { payload?: Record<string, unknown> | null }) {
  const { t, locale } = useT();
  if (!payload) return null;

  const rows = payload['rows'];
  if (!Array.isArray(rows) || rows.length === 0) return null;

  const columns = payload['columns'];
  const rowsLuu = payload['rowsLuu'];
  const rowCount = payload['rowCount'];
  const daCat =
    typeof rowsLuu === 'number' && typeof rowCount === 'number' && rowsLuu < rowCount
      ? { luu: rowsLuu, tong: rowCount }
      : undefined;

  // Lượt nhiều nguồn: bảng lưu lại là của nguồn đầu tiên. Im lặng thì người mở lại thấy MỘT bảng dưới câu trả lời nói
  // về ba nguồn — nên nói ra.
  const nguon = payload['nguon'];
  const dsNguon = Array.isArray(nguon) ? (nguon as { ten?: string; soDong?: number; loi?: string }[]) : [];
  const nhanCot = payload['nhanCot'];

  return (
    <div className="mt-2">
      <KhoiSoLieu
        rows={rows as Record<string, unknown>[]}
        columns={Array.isArray(columns) ? (columns as string[]) : undefined}
        nhanCot={nhanCot && typeof nhanCot === 'object' ? (nhanCot as Record<string, string>) : undefined}
        display={payload['display'] as AskDisplay | undefined}
        veBang={typeof payload['veBang'] === 'boolean' ? payload['veBang'] : undefined}
        hoiDanhSach={payload['hoiDanhSach'] !== false}
        daCat={daCat}
      />
      {/* Im lặng hiện 140 dòng cho một kết quả 200 dòng là để người đọc tin rằng đó là toàn bộ. */}
      {daCat ? (
        <p className="mt-1 text-xs text-warning-700">
          {t('troLyAiHoiLuot.soLieuDaCat', { luu: soVN(daCat.luu, locale), tong: soVN(daCat.tong, locale) })}
        </p>
      ) : null}
      {dsNguon.length > 1 ? (
        <p className="mt-1 text-xs text-content-muted">
          {t('troLyAiHoiLuot.luotNhieuNguon', {
            ds: dsNguon
              .map((n) =>
                t('troLyAiHoiLuot.nguonTomTat', {
                  ten: n.ten ?? '?',
                  chiTiet: n.loi ? n.loi : t('troLyAiHoiLuot.dong', { n: soVN(n.soDong ?? 0, locale) }),
                }),
              )
              .join(' · '),
          })}
        </p>
      ) : null}
    </div>
  );
}
